import { render, staticRenderFns } from "./CardSwitcher.vue?vue&type=template&id=7db7a152"
import script from "./CardSwitcher.vue?vue&type=script&lang=js"
export * from "./CardSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports